import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import usePenStudyAnalyses from 'hooks/usePenStudyAnalyses';
import { penStudyAnalysesSelectors } from "features/penStudyAnalyses";

const PenStudyAnalysesList = () => {
  const { getPenStudyAnalyses } = usePenStudyAnalyses();
  const { data, pagination } = useCustomSelector(penStudyAnalysesSelectors.getPenStudyAnalysesData);
  const fetching = useCustomSelector(penStudyAnalysesSelectors.penStudyAnalysesIsFetching);
  
  return (
    <BaseAnalysesList
      fetchData={getPenStudyAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <PenStudyAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);